// Dutch translations
export const nl: Record<string, string> = {
  // Main Menu
  'menu.dashboard': 'Dashboard',
  'payment.adjustment': 'Saldocorrectie',
  'menu.orderNew': 'Product Registratie',
  'menu.deliveryList': 'Leveringslijst',
  'menu.delivery': 'Levering',
  'menu.receipt': 'Bon/Label Printen',
  'menu.carWash': 'Autowasstraat',
  'menu.referral': 'Uitnodigen',
  'menu.driverPickup': 'Op te halen bestellingen',
  'menu.hardware': 'Hardware',
  'menu.payment': 'Betaling',
  'menu.reportsCharts': 'Grafiekrapporten',
  'menu.barber': 'Barbier / Kapper',
  'menu.definitions': 'Definities',
  'menu.customers': 'Klanten',
  'menu.products': 'Product Definities',
  'menu.pricing': 'Prijs Definities',
  'menu.tailoring': 'Naai Operaties',
  'menu.attributes': 'Product Attributen',
  'menu.users': 'Gebruikers',
  'menu.productOrdering': 'Product Ordening',
  'menu.discounts': 'Korting Definities',
  'menu.settings': 'Instellingen',
  'menu.generalSettings': 'Algemene Instellingen',
  'menu.permissions': 'Rechten Beheer',
  'menu.subscription': 'Abonnement',
  'menu.invoices': 'Factuur Beheer',
  'menu.expenses': 'Kosten Invoer',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'Rapporten & Boekhouding',
  'menu.systemAndCommunication': 'Systeem & Communicatie',
  'menu.reportsList': 'Bonnen Lijst',
  'menu.accountStatement': 'Rekeningafschrift',
  'menu.tickets': 'Support Verzoeken',
  'menu.support': 'Support',
  'menu.profile': 'Profiel',
  'menu.logout': 'Uitloggen',
  'menu.notifications': 'SMS/WhatsApp Meldingen',
  'menu.whatsappConnection': 'WhatsApp Verbinding',
  'menu.smsConnection': 'SMS Verbinding',
  
  // Dashboard
  'dashboard.title': 'Dashboard',
  'dashboard.todaySales': 'Verkopen Vandaag',
  'dashboard.totalOrders': 'Totaal Bestellingen',
  'dashboard.pendingDeliveries': 'Lopende Leveringen',
  'dashboard.activeCustomers': 'Actieve Klanten',
  'dashboard.recentOrders': 'Recente Bestellingen',
  'dashboard.viewAll': 'Bekijk Alles',
  'dashboard.quickActions': 'Snelle Acties',
  'dashboard.newOrder': 'Nieuwe Bestelling',
  'dashboard.newCustomer': 'Nieuwe Klant',
  'dashboard.deliveries': 'Leveringen',
  'dashboard.reports': 'Rapporten',
  'dashboard.today': 'Vandaag',
  'dashboard.yesterday': 'Gisteren',
  'dashboard.week': 'Week',
  'dashboard.month': 'Maand',
  'dashboard.quarter': 'Kwartaal',
  'dashboard.year': 'Jaar',
  'dashboard.totalRevenue': 'Totale Omzet',
  'dashboard.totalOrdersCard': 'Totaal Bestellingen',
  'dashboard.totalPieces': 'Totaal Stuks',
  'dashboard.cancelled': 'Geannuleerd',
  'dashboard.inProcess': 'In Behandeling',
  'dashboard.inProcessDesc': 'Bestellingen in behandeling',
  'dashboard.ready': 'Klaar',
  'dashboard.readyDesc': 'Bestellingen klaar voor levering',
  'dashboard.delivered': 'Geleverd',
  'dashboard.deliveredDesc': 'Voltooide bestellingen',
  'dashboard.announcements': 'Aankondigingen',
  'dashboard.announcementAll': 'Algemeen',
  'dashboard.announcementPrivate': 'Privé',
  
  // Order Entry
  'order.title': 'Nieuwe Bestelling',
  'order.customer': 'Klant',
  'order.selectCustomer': 'Selecteer Klant',
  'order.newCustomer': 'Nieuwe Klant',
  'order.products': 'Producten',
  'order.addProduct': 'Product Toevoegen',
  'order.selectProduct': 'Selecteer Product',
  'order.quantity': 'Aantal',
  'order.price': 'Prijs',
  'order.total': 'Totaal',
  'order.discount': 'Korting',
  'order.subtotal': 'Subtotaal',
  'order.tax': 'BTW',
  'order.grandTotal': 'Eindtotaal',
  'order.payment': 'Betaling',
  'order.paymentMethod': 'Betaalmethode',
  'order.cash': 'Contant',
  'order.card': 'Creditcard',
  'order.credit': 'Op Rekening',
  'order.amountPaid': 'Betaald Bedrag',
  'order.remainingBalance': 'Resterend Saldo',
  'order.deliveryDate': 'Leverdatum',
  'order.notes': 'Notities',
  'order.createOrder': 'Bestelling Maken',
  'order.cancel': 'Annuleren',
  
  // Users
  'users.title': 'Gebruikers',
  'users.addNew': 'Nieuwe Gebruiker',
  'users.name': 'Naam',
  'users.email': 'E-mail',
  'users.role': 'Rol',
  'users.pin': 'PIN',
  'users.permissions': 'Rechten',
  'users.allPermissions': 'Alle Rechten',
  'users.permissionCount': '{count} rechten',
  'users.changePin': 'PIN Wijzigen',
  'users.edit': 'Bewerken',
  'users.delete': 'Verwijderen',
  'users.newUser': 'Nieuwe Gebruiker',
  'users.editUser': 'Gebruiker Bewerken',
  'users.editingUser': '{name} bewerken',
  'users.deleteUserTitle': 'Gebruiker Verwijderen',
  'users.deletingUser': 'Weet u zeker dat u {name} wilt verwijderen?',
  'users.pinCode': 'PIN Code (4-6 cijfers)',
  'users.selectRole': 'Selecteer rol',
  'users.patron': 'Eigenaar',
  'users.kasiyer': 'Kassier',
  'users.sofor': 'Chauffeur',
  'users.eleman': 'Medewerker',
  'users.changePinTitle': 'PIN Code Wijzigen',
  'users.newPin': 'Nieuwe PIN Code',
  'users.confirmPin': 'PIN Code Bevestigen',
  'users.pinMismatch': 'PIN codes komen niet overeen',
  'users.pinRequired': 'PIN code verplicht',
  'users.pinLength': 'PIN code moet 4-6 cijfers bevatten',
  'users.changingPinFor': 'PIN wijzigen voor {name}',
  
  // Products
  'products.title': 'Product Definities',
  'products.addNew': 'Nieuw Product',
  'products.category': 'Categorie',
  'products.name': 'Productnaam',
  'products.price': 'Prijs',
  'products.color': 'Kleur',
  'products.active': 'Actief',
  'products.actions': 'Acties',
  'products.search': 'Zoek Product...',
  'products.noProducts': 'Geen producten gevonden',
  'products.noCategoryProducts': 'Geen producten in deze categorie',
  'products.emptyCart': 'Winkelwagen leeg',
  
  // Service Types
  'service.tailor': 'Kleermaker',
  'service.dryCleaning': 'Stomerij',
  'service.washing': 'Wassen',
  'service.ironing': 'Strijken',
  'service.dyeing': 'Verven',
  'pricing.dyeing': 'Verven',
  'service.dyeingShort': 'Verven',
  'service.shoeShine': 'Schoenen Poetsen',
  'service.carpet': 'Tapijt',
  'service.tailoring': 'Verstelwerk',
  'service.carpetWashing': 'Tapijt Wassen',
  'service.sofaWashing': 'Bankreiniging',
  'service.carWash': 'Autowassen & Detailing',
  'service.barber': 'Kapper / Barbier',
  'service.selectService': 'Selecteer service',
  'service.addToCart': 'Toevoegen aan Winkelwagen',
  'service.total': 'Totaal',
  
  // Common
  'common.yes': 'Ja',
  'common.no': 'Nee',
  'common.cancel': 'Annuleren',
  'common.confirm': 'Bevestigen',
  'common.delete': 'Verwijderen',
  'common.edit': 'Bewerken',
  'common.save': 'Opslaan',
  'common.search': 'Zoeken',
  'common.loading': 'Laden...',
  'common.noData': 'Geen data',
  'common.actions': 'Acties',
  'common.status': 'Status',
  'common.date': 'Datum',
  'common.time': 'Tijd',
  'common.total': 'Totaal',
  'common.filter': 'Filteren',
  'common.export': 'Exporteren',
  'common.print': 'Printen',
  'common.close': 'Sluiten',
  'common.back': 'Terug',
  'common.next': 'Volgende',
  'common.previous': 'Vorige',
  'common.submit': 'Verzenden',
  'common.reset': 'Resetten',
  'common.create': 'Maken',
  'common.creating': 'Maken...',
  'common.later': 'Later',
  'common.clear': 'Wissen',
  'common.copied': 'Gekopieerd!',
  'common.copyError': 'Kopiëren mislukt',
  'common.perPage': 'Per pagina',
  'common.page': 'Pagina',
  'common.orders': 'Bestellingen',
  'common.pieces': 'stuks',
  
  // Login
  'login.title': 'Cleandy',
  'login.subtitle': 'Stomerij Beheersysteem',
  'login.tenantId': 'Bedrijf ID',
  'login.tenantPlaceholder': 'bedrijf-id (bijv: acme-clean)',
  'login.tenantIdHelp': 'Voer uw unieke bedrijfs-ID in',
  'login.continue': 'Doorgaan →',
  'login.notMember': 'Nog geen lid?',
  'login.startTrial': 'Start Gratis Proefperiode',
  'login.adminLogin': '🔒 Administrator Login',
  'login.enterPin': 'Voer uw PIN code in',
  'login.changeTenant': 'Bedrijf Wijzigen',
  'login.clear': 'Wissen',
  'login.delete': 'Verwijderen',
  'login.login': 'Inloggen',
  'login.loggingIn': 'Inloggen...',
  'login.defaultPinOwner': 'Standaard PIN: <strong>1234</strong> (Eigenaar)',
  'login.defaultPinCashier': 'Standaard PIN: <strong>0000</strong> (Kassier)',
  'login.systemInitializing': 'Systeem initialiseren...',
  'login.pinMinLength': 'PIN moet minimaal 4 cijfers bevatten',
  'login.invalidTenantId': 'Voer een geldig bedrijf ID in',
  'login.tenantNotFound': 'Deze bedrijfscode is niet gevonden. Controleer of maak een nieuw account aan.',
  'login.loginFailed': 'Inloggen mislukt',
  'login.welcome': 'Welkom, {name}',

  // Signup translations
  'signup.title': 'Start Gratis Proefperiode',
  'signup.subtitle': '15 dagen gratis proberen, geen creditcard nodig',
  'signup.backToLogin': 'Terug naar Login Pagina',
  'signup.companyCode': 'Bedrijfscode',
  'signup.companyCodePlaceholder': 'bijv: cleanpro',
  'signup.companyCodeHelp': 'Deze code wordt gebruikt om in te loggen in het systeem',
  'signup.companyCodeMinLength': 'Bedrijfscode moet minimaal 3 tekens bevatten',
  'signup.companyName': 'Bedrijfsnaam',
  'signup.companyNamePlaceholder': 'Uw Bedrijfsnaam',
  'signup.companyNameRequired': 'Bedrijfsnaam is verplicht',
  'signup.fullName': 'Volledige Naam',
  'signup.fullNamePlaceholder': 'Uw Volledige Naam',
  'signup.fullNameRequired': 'Volledige naam is verplicht',
  'signup.phone': 'Telefoon',
  'signup.phonePlaceholder': '+31 6 12345678',
  'signup.validPhoneRequired': 'Voer een geldig telefoonnummer in',
  'signup.email': 'E-mail',
  'signup.emailPlaceholder': 'voorbeeld@bedrijf.nl',
  'signup.validEmailRequired': 'Voer een geldig e-mailadres in',
  'signup.createAccount': 'Account Aanmaken',
  'signup.creating': 'Aanmaken...',
  'signup.terms': 'Door een account aan te maken, gaat u akkoord met de Gebruiksvoorwaarden en het Privacybeleid.',
  'signup.success': 'Registratie geslaagd! Uw inloggegevens zijn naar uw e-mailadres verzonden.',
  'signup.successTitle': 'Registratie Geslaagd!',
  'signup.successMessage': 'Uw account is succesvol aangemaakt.',
  'signup.emailSent': 'Uw inloggegevens zijn naar uw e-mailadres verzonden.',
  'signup.redirecting': 'Omleiden naar login pagina...',
  'signup.startupPackageLoaded': 'Startpakket Geladen!',
  'signup.products': 'Producten',
  'signup.customers': 'Klanten',
  'signup.users': 'Gebruikers',
  'signup.demoDataReady': '✨ Uw demo data is klaar, u kunt direct beginnen met gebruiken!',
  'signup.loginInfo': '📧 Uw Inloggegevens',
  'signup.loginInfoSent': '💡 Deze informatie is ook naar uw e-mailadres verzonden',
  'signup.loginNow': 'Nu Inloggen →',
  'signup.hints.companyCode': 'Gebruikt voor inloggen',
  'signup.hints.country': 'Uw land is automatisch gedetecteerd. U kunt een ander land selecteren.',
  'signup.freeTrial': '🎉 Probeer gratis 15 dagen - Geen creditcard nodig!',
  'signup.bt.tailoring.desc': 'Kleermakerij, aanpassingen en naaidiensten',
  'signup.bt.barber.desc': 'Kapper, barbier en schoonheidssalon',
  'signup.businessType.question': 'Wat voor bedrijf heeft u?',
  'signup.businessType.hint': 'Uw standaardscherm wordt automatisch ingesteld op basis van uw keuze',
  'signup.businessType.continue': 'Doorgaan',
  'signup.bt.dryCleaning.desc': 'Reiniging van kleding, gordijnen en textiel',
  'signup.bt.carpetWashing.desc': 'Reiniging van tapijten, vloerkleden en lopers',
  'signup.bt.sofaWashing.desc': 'Reiniging van banken, fauteuils en zitmeubels',
  'signup.bt.carWash.desc': 'Autowassen, waxen, polijsten en detailing',
  'signup.bt.shoeShine.desc': 'Schoenreiniging en -verzorging',
  'signup.companyDetails': 'Bedrijfsgegevens',
  'signup.errors.companyCodeRequired': 'Bedrijfscode is verplicht',
  'signup.errors.companyCodeTooShort': 'Bedrijfscode moet minimaal 3 tekens hebben',
  'signup.errors.companyNameRequired': 'Bedrijfsnaam is verplicht',
  'signup.errors.emailInvalid': 'Voer een geldig e-mailadres in',
  'signup.errors.emailRequired': 'E-mailadres is verplicht',
  'signup.errors.ownerNameRequired': 'Volledige naam is verplicht',
  'signup.errors.signupFailed': 'Registratie mislukt',
  'signup.fields.companyCode': 'Bedrijfscode',
  'signup.fields.companyName': 'Bedrijfsnaam',
  'signup.fields.country': 'Land',
  'signup.fields.email': 'E-mailadres',
  'signup.fields.ownerName': 'Volledige naam',
  'signup.fields.phone': 'Telefoonnummer',
  'signup.haveAccount': 'Heeft u al een account? Inloggen',
  'signup.placeholders.companyCode': 'bijv.: cleanpro',
  'signup.placeholders.companyName': 'bijv.: CleanPro Stomerij',
  'signup.placeholders.email': 'bijv.: jan@cleanpro.com',
  'signup.placeholders.ownerName': 'bijv.: Jan Jansen',
  'signup.placeholders.phone': 'bijv.: +31 6 12345678',
  'signup.referral.bonus': 'Uitnodigingsbonus',
  'signup.referral.title': 'Uitnodigingscode',

  // Settings
  'settings.title': 'Instellingen',
  'settings.save': 'Opslaan',
  'settings.loading': 'Laden...',
  'settings.general': 'Algemene instellingen',
  'settings.languageRegion': 'Taal en regio',
  'settings.language': 'Taal',
  'settings.currency': 'Valuta',
  'settings.currencyPosition': 'Valutapositie',
  'settings.currencyPositionLeft': 'Links (€100)',
  'settings.currencyPositionRight': 'Rechts (100€)',
  'settings.numberFormat': 'Nummerformaat',
  'settings.numberFormatDotComma': 'Punt voor decimalen (1.234,56)',
  'settings.numberFormatCommaDot': 'Komma voor decimalen (1,234.56)',
  'settings.numberFormatSpaceComma': 'Spatie voor decimalen (1 234,56)',
  'settings.showDecimals': 'Decimalen weergeven',
  'settings.showDecimalsDesc': '2 decimalen voor bedragen weergeven',
  'settings.dateFormat': 'Datumnotatie',
  'settings.timezone': 'Tijdzone',
  'settings.taxRate': 'Belastingtarief',
  'settings.receiptSettings': 'Kassabon-instellingen',
  'settings.logo': 'Logo',
  'settings.removeLogo': 'Logo verwijderen',
  'settings.uploadLogo': 'Logo uploaden',
  'settings.companyName': 'Bedrijfsnaam',
  'settings.companyNamePlaceholder': 'Voer bedrijfsnaam in',
  'settings.phone': 'Telefoon',
  'settings.address': 'Adres',
  'settings.addressPlaceholder': 'Voer adres in',
  'settings.footerText': 'Voettekst',
  'settings.footerTextPlaceholder': 'Voer voettekst in',
  'settings.receiptNote': 'Kassabonnotitie',
  'settings.receiptNotePlaceholder': 'Voer kassabonnotitie in',
  'settings.socialMedia': 'Sociale media',
  'settings.website': 'Website',
  'settings.dangerZone': 'Gevaarlijke zone',
  'settings.deleteDemoData': 'Demo-gegevens verwijderen',
  'settings.deleteDemoDataTitle': 'Demo-gegevens verwijderen',
  'settings.deleteDemoDataConfirm': 'Dit kan niet ongedaan worden gemaakt! De voorbeeldklanten en hun bonnen/betalingen worden verwijderd; uw eigen klanten en bonnen blijven behouden.',
  'toast.noDemoData': 'Geen voorbeeldklanten gevonden om te verwijderen.',
  'toast.demoCustomersKept': '{n} voorbeeldklant(en) behouden omdat er door u gemaakte bonnen zijn; alleen de voorbeeldbonnen zijn verwijderd.',
  'toast.demoDataDeleted': 'Voorbeeldgegevens verwijderd',
  'toast.selectCustomer': 'Selecteer een klant',
  'settings.deleteDemoDataWarning': 'Verwijdert de voorbeeldklanten die bij de installatie automatisch zijn toegevoegd, samen met hun bonnen en betalingen. Klanten en bonnen die u zelf hebt toegevoegd, worden niet verwijderd.',
  'settings.productsWillBeKept': 'Producten worden bewaard',
  'settings.areYouSure': 'Weet je het zeker?',
  'settings.deleting': 'Verwijderen...',
  'settings.loadSchema': 'Schema laden',
  'settings.loadSchemaTitle': 'Databaseschema laden',
  'settings.loadSchemaConfirm': 'Dit zal het databaseschema maken. Doorgaan?',
  'settings.connected': 'Verbonden',
  'settings.notConnected': 'Niet verbonden',
  'settings.connect': 'Verbinden',
  'settings.disconnect': 'Verbinding verbreken',
  'settings.showTax': 'Belasting weergeven',
  'settings.headerInfo': 'Header info',
  'settings.headerInfoPlaceholder': 'bijv: Stomerij & Strijken',
  'settings.footerTextHelp': 'Kort bericht onder aan kassabon',
  'settings.receiptNoteHelp': 'Gedetailleerde voorwaarden',
  'settings.receiptPreview': 'Kassabon preview',
  'settings.expenses': 'Uitgaven',
  'settings.invoices': 'Facturen',
  'settings.reports': 'Rapporten',
  'settings.tickets': 'Support tickets',
  'settings.zReport': 'Z Report',

  // Z-Report
  'zReport.singleDay': 'Eénige dag',
  'zReport.dateRange': 'Datumbereik',
  'zReport.startDate': 'Startdatum',
  'zReport.endDate': 'Einddatum',
  'zReport.totalOrders': 'Totaal bestellingen',
  'zReport.cancelledOrders': 'Geannuleerde bestellingen',
  'zReport.totalRevenue': 'Totale omzet',
  'zReport.paymentMethods': 'Betaalmethoden',
  'zReport.cash': 'Contant',
  'zReport.creditCard': 'Creditcard',
  'zReport.account': 'Rekening',
  'zReport.free': 'Gratis',
  'zReport.paidAtRegister': 'Betaald bij registratie',
  'zReport.paidAtDelivery': 'Betaald bij levering',
  'zReport.collectionDetails': 'Inningdetails',
  'zReport.incoming': 'Inkomend',
  'zReport.outgoing': 'Uitgaand',
  'zReport.totalRegistered': 'Totaal geregistreerd',
  'zReport.expenses': 'Kosten',
  'zReport.noExpenses': 'Geen kosten',
  'zReport.totalExpenses': 'Totale kosten',
  'zReport.cancelledReceipts': 'Geannuleerde bonnen',
  'zReport.reason': 'Reden',
  'zReport.noCancelled': 'Geen geannuleerde bonnen',
  'zReport.totalCancelled': '{count} geannuleerde bonnen',
  'zReport.serviceBreakdown': 'Uitsplitsing per service',
  'zReport.loadError': 'Rapport niet geladen',
  'zReport.excelError': 'Excel export fout',
  'zReport.excelDownloaded': 'Excel gedownload',
  'zReport.loading': 'Laden...',
  'zReport.todayOrders': 'Bestellingen van vandaag',
  'zReport.registrationAndDelivery': 'Registratie + Levering',
  'zReport.orderPaidAtRegister': 'Bestelling betaald bij registratie',
  'zReport.orderPaidAtDelivery': 'Bestelling betaald bij levering',
  'zReport.accountCollections': 'Innings rekening',
  'zReport.totalCollection': 'Totale innig',
  'zReport.bankTransfer': 'Bankoverschrijving',
  'zReport.cashRegister': 'Kasregister',
  'zReport.startingCash': 'Begincontant',
  'zReport.dailyCashIncome': 'Dagelijkse cash inkomsten',
  'zReport.cashToDeliver': 'Cash te leveren',
  'zReport.cashCalculation': '(Begin + Cash vandaag - Kosten)',

  // Receipt Page
  'receipt.title': 'Kassabon',
  'receipt.receiptNumber': 'Bon nr.',
  'receipt.date': 'Datum',
  'receipt.subtotal': 'Subtotaal',
  'receipt.payment': 'Betaling',
  'receipt.thankYou': 'Bedankt!',

  'customerStatement.receiptDelivered': 'Afgeleverd',
  'customerStatement.receiptOpen': 'Open',
  'customerStatement.selectDateRange': 'Datumbereik selecteren',
  'customerStatement.thisMonth': 'Deze maand',
  'customerStatement.lastMonth': 'Vorige maand',
  'customerStatement.allTime': 'Alle tijd',
  'customerStatement.startDate': 'Begindatum',
  'customerStatement.endDate': 'Einddatum',
  'customerStatement.printPDF': 'Afschrift afdrukken (PDF)',
  'customerStatement.title': 'REKENINGAFSCHRIFT',
  'customerStatement.customerName': 'Klantnaam',
  'customerStatement.phone': 'Telefoon',
  'customerStatement.address': 'Adres',
  'customerStatement.openingBalance': 'Beginsaldo',
  'customerStatement.closingBalance': 'Eindsaldo',
  'customerStatement.description': 'Omschrijving',
  'customerStatement.type': 'Type',
  'customerStatement.debit': 'Debet',
  'customerStatement.credit': 'Credit (ontvangen)',
  'customerStatement.total': 'TOTAAL',
  'customerStatement.cancelled': 'GEANNULEERD',
  'customerStatement.payment': 'Betaling',
  'customerStatement.items': 'items',
  'customerStatement.noTransactions': 'Geen transacties in de geselecteerde periode.',
  'customerStatement.statementDate': 'Afschriftdatum',

  'tailoring.title': 'Kleermakersdiensten',
  'tailoring.addNew': 'Nieuwe Operatie',
  'tailoring.subtitle': 'Hier kunt u de prijzen voor kleermakersdiensten bijwerken',
  'tailoring.addNewDescription': 'Een aangepast type kleermaakersoperatie toevoegen',
  'tailoring.add': 'Toevoegen',
  'tailoring.savePrices': 'Prijzen opslaan',
  'tailoring.default': 'Standaard',
  'tailoring.infoTitle': 'Informatie',
  'tailoring.info1': 'Klik na het wijzigen van prijzen op "Prijzen opslaan"',
  'tailoring.info2': 'Met "Nieuwe Operatie" kunt u aangepaste operatietypen toevoegen',
  'tailoring.info3': 'Aangepaste operaties kunnen worden verwijderd met het prullenbakpictogram',
  'tailoring.info4': 'Deze prijzen worden gebruikt bij het aanmaken van bestellingen met kleermakersdienst',
  'tailoring.info5': 'U kunt een aparte prijs instellen voor elke kleermaakersoperatie',
  'tailoring.info6': 'Prijzen worden automatisch berekend bij toevoeging aan winkelwagen',
  'tailoring.loadError': 'Prijzen konden niet worden geladen',
  'tailoring.nameRequired': 'Voer een operatienaam in',
  'tailoring.invalidPrice': 'Voer een geldige prijs in',
  'tailoring.addSuccess': 'Nieuwe kleermaakersoperatie toegevoegd!',
  'tailoring.saveError': 'Opslagfout',
  'tailoring.deleteConfirm': 'Weet u zeker dat u deze operatie wilt verwijderen?',
  'tailoring.deleteSuccess': 'Operatie verwijderd',
  'tailoring.deleteError': 'Verwijderfout',
  'tailoring.saveSuccess': 'Kleermakersprijzen opgeslagen!',
  'tailoring.addNewTitle': 'Nieuwe kleermaakersoperatie toevoegen',
  'tailoring.operationNameLabel': 'Operatienaam',
  'tailoring.priceLabel': 'Prijs',
  'tailoring.iconLabel': 'Pictogram (Emoji)',
  'tailoring.operationNamePlaceholder': 'Bijv: Kraagnaad',
  'tailoring.cancel': 'Annuleren',
  'tailoring.save': 'Opslaan',
  'tailoring.icon': 'Pictogram',
  'tailoring.operationName': 'Operatienaam',
  'tailoring.price': 'Prijs',
  'tailoring.addCustom': 'Aangepast toevoegen',

  'hardware.title': 'Hardwarewinkel',
  'hardware.subtitle': 'Bonprinters, labelprinters en Caller ID-apparaten',
  'hardware.cart': 'Winkelwagen',
  'hardware.infoTitle': 'Informatie',
  'hardware.infoText': 'Deze hardwareproducten zijn momenteel alleen beschikbaar voor aankoop in Turkije. Ze zijn voor informatieve doeleinden vermeld voor andere landen.',
  'hardware.myCart': 'Mijn winkelwagen',
  'hardware.cartEmpty': 'Winkelwagen leeg',
  'hardware.vatSuffix': '+ btw',
  'hardware.total': 'Totaal',
  'hardware.checkout': 'Naar betaling',
  'hardware.receiptPrinters': 'Bonprinters',
  'hardware.receiptPrintersSubtitle': '80mm thermische printers met automatische snijder',
  'hardware.compatibilityTitle': 'CleandySoft compatibiliteit',
  'hardware.receiptCompatText': 'Werkt met alle 80mm thermische printers met automatische snijder.',
  'hardware.labelPrinters': 'Labelprinters',
  'hardware.labelPrintersSubtitle': 'Matrixprinters, 76mm/57mm (Epson TM-U220, Bixolon SRP-270)',
  'hardware.testedModels': 'Geteste modellen',
  'hardware.labelCompatText': 'Getest voor Epson TM-U220 en Bixolon SRP-270. Andere merken of modellen kunnen problemen ondervinden.',
  'hardware.callerIdTitle': 'Caller ID-apparaten',
  'hardware.callerIdSubtitle': 'Identificatie van klantoproepen',
  'hardware.compatibilityNote': 'Compatibiliteitsopmerking',
  'hardware.callerIdCompatText': 'Alleen getest voor CIDShow 2-lijns model. Andere merken of modellen kunnen werken maar zijn niet gegarandeerd.',
  'hardware.barcodeScanners': 'Barcodescanners',
  'hardware.barcodeScannerSubtitle': 'USB barcode- en QR-codescanners',
  'hardware.barcodeCompatText': 'Alle 2D barcodescanners kunnen werken met CleandySoft. Scanners in USB HID-modus worden automatisch ondersteund.',
  'hardware.driverDownloads': 'Driver- en softwaredownloads',
  'hardware.driverDownloadsText': 'Het wordt aanbevolen de juiste driver te downloaden voordat u de printer aansluit.',
  'hardware.onlyTurkey': 'Dit product is alleen beschikbaar voor aankoop in Turkije',
  'hardware.addedToCart': 'Toegevoegd aan winkelwagen!',
  'hardware.available': 'Beschikbaar',
  'hardware.info': 'Info',
  'hardware.features': 'Kenmerken',
  'hardware.addToCart': 'In winkelwagen',
  'hardware.infoOnly': 'Alleen informatief',
  'expenses.expenseType': 'Uitgavetype',
  'expenses.allBranches': 'Alle vestigingen',
  'expenses.noBranch': 'Geen vestiging',
  'expenses.allTypes': 'Alle typen',
  'expenses.categoryBy': 'Per categorie',
  'expenses.records': 'records',
  'expenses.exportExcel': 'Excel',
  'expenses.excelError': 'Excel-bestand kon niet worden aangemaakt',
  'expenses.branchSelect': 'Kies vestiging',
  'expenses.noBranchSelected': '— Geen vestiging geselecteerd —',
  'expenses.myBranch': 'Mijn vestiging',
  'expenses.canOnlyDeleteToday': 'U kunt alleen de kosten verwijderen die u vandaag heeft ingevoerd.',
  'subscription.referralDesc': 'Als een vriend die je uitnodigt zich registreert en lid wordt, krijg je 1 maand extra! Alleen een uitnodiging sturen is niet genoeg.',
  'dashboard.referral.desc': '1 maand extra als een uitgenodigd bedrijf zich registreert!',
};
